import { render, staticRenderFns } from "./customer-sale-rank.vue?vue&type=template&id=c9f82610&scoped=true&"
import script from "./customer-sale-rank.vue?vue&type=script&lang=js&"
export * from "./customer-sale-rank.vue?vue&type=script&lang=js&"
import style0 from "./customer-sale-rank.vue?vue&type=style&index=0&id=c9f82610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f82610",
  null
  
)

export default component.exports